import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import { store } from '../store'
import headersEndpointsAgendamento from '../consts/headersEndpointAgendamento'
import { armazenarErroGenerico } from '../store/error/actions'
import MixpanelHelper from '../utils/helpers/mixpanelHelper'

class RequisicaoAdapter {
  private static Axios: AxiosInstance = axios.create({
    headers: headersEndpointsAgendamento
  })

  public static request<T>(
    config: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    const paginaOrigem = window.location.href

    return RequisicaoAdapter.Axios.request<T>(config).catch(
      (error: AxiosError) => {
        const { dispatch } = store
        if (error.response) {
          dispatch(armazenarErroGenerico(error.response))
        }

        MixpanelHelper.sendEventExibirErros(paginaOrigem, error)

        return Promise.reject(error)
      }
    )
  }
}

export default RequisicaoAdapter
